/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import ApplicationState         from 'g3w-state';
  import { fieldsMixin }          from 'mixins';
  import Link                     from 'components/FieldLink.vue';
  import VueField                 from 'components/FieldVue.vue';
  import Image                    from 'components/FieldImage.vue'
  import { toRawType }            from 'utils/toRawType';
  import { throttle }             from 'utils/throttle';
  import { getCatalogLayerById }  from 'utils/getCatalogLayerById';
  import { downloadFeatures }     from 'utils/downloadFeatures';
  import GUI                      from 'g3w-app';
  import { Layer }                from 'g3w-layer';
  import { getAlphanumericProps } from 'utils/getAlphanumericProps';
  
  const HEADERTYPESFIELD = [
    'varchar',
    'integer',
    'float',
    'bigint', //@since v3.9
    'date',
  ];

  const __vue_script__ = {

    /** @since 3.8.6 */
    name: 'queryresults',

    data() {
      return {
        state:                       ApplicationState,
        headerExpandActionCellWidth: 10,
        headerActionsCellWidth:      10,
        /** @since 4.1.0 */
        proxied_layers:              [],
        /** @since 4.2.0 cache feature action visibility to avoid render loops */
        layer_feature_actions:       {},
      }
    },

    mixins: [fieldsMixin],

    components: {
      'g3w-link':  Link,
      'g3w-vue':   VueField,
      'g3w-image': Image,
    },

    computed: {

      onelayerresult() {
        return 1 === this.state.queried_layers.length;
      },

      hasLayers() {
        return this.hasResults || this.state?.components?.length > 0;
      },

      hasResults() {
        return this.state.queried_layers.length > 0;
      },

      /**
       * @typedef QueryResultsInfo
       * 
       * @property { string | null }     icon
       * @property { string | null }     message
       */
      /**
       * @returns { QueryResultsInfo } query info
       */
      info() {
        const precision = 'degrees' === GUI.getMapUnits() ? 4 : 2;

        if ('coordinates' === this.state?.query?.type) {
          return {
            icon:    'marker',
            message: `  ${this.state.query.coordinates[0].toFixed(precision)}, ${this.state.query.coordinates[1].toFixed(precision)}`
          };
        }

        if ('bbox' === this.state?.query?.type) {
          return {
            icon:    'square',
            message: `  [${this.state.query.bbox.map(c => c.toFixed(precision)).join(' , ')}]`
          };
        }

        if ('circle' === this.state?.query?.type) {
          return {
            icon:    'empty-circle',
            message: ' ',
          };
        }

        if (['polygon', 'drawpolygon'].includes(this.state?.query?.type)) {
          return {
            icon: 'draw',
            message: 
              this.state.query.layerName
              ? `${this.state.query.layerName} ${undefined !== this.state.query.fid ? ` - Feature Id: ${this.state.query.fid}` : ''}` // <Feature ID>:   when polygon feature comes from a Feature layer
              : ' '                                                                                                                   // <empty string>: when polygon feature comes from a Drawed layer (temporary layer)
          };
        }

        return { icon: null, message: null };
      },

      queryableLayers() {
        return Object.values(ApplicationState.layers)
          .flatMap(s => s.isQueryable() ? s.getLayers() : [])
          .filter(l => l.isGeoLayer() && l.isQueryable());
      },

      selectedLayer() {
        return GUI.getSelectedLayer();
      },

    },

    methods: {

      /**
       * @since 4.1.1 - Inject layer data raw data within and <iframe>
       */
      setRawdataIframeContent(event, layer) {
        try {
          const iframe = event?.target;
          const doc    = iframe?.contentDocument;

          // skip when iframe is not ready
          if (!doc) {
            return;
          }

          // inject html or text contect (within iframe)
          doc.body.innerHTML = 'text/plain' === layer.infoformat
            ? /* html */`<pre style="margin:0; white-space:pre-wrap; overflow-wrap:anywhere; word-break:break-word; overflow:hidden hidden;">${String(layer.rawdata || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')}</pre>`
            : (layer.rawdata || '');

          // intercept click on links (within iframe)
          doc.body.addEventListener('click', async e => {
            const anchor = e.target.closest('a');
            if (anchor) {
              e.preventDefault();
              const url = anchor.getAttribute('href');
              const ok = await GUI.confirm(`<h4>🚨 ${this.$t('Open external link?')}</h4><p>${url}</p>`);
              if (ok) {
                window.open(url, '_blank', 'noopener,noreferrer');
              }
            }
          });

          // html content → keep horizontal scrollbar
          doc.head.innerHTML = /* html */`<style>
            html, body { overflow: ${'text/plain' === layer.infoformat ? 'hidden' : 'auto'} hidden; margin: 0; }
          </style>`;

          // watch for layout changes (within iframe)
          (new ResizeObserver(([entry]) => {
            iframe.style.height = `${Math.max(120, Math.ceil(entry.borderBoxSize?.[0]?.blockSize || entry.contentRect.height))}px`;
          })).observe(doc.documentElement);

        } catch(e) {
          console.warn(e);
        }
      },

      /**
       * @returns { boolean } whether can paginate layer results
       */
      canPaginate(layer) {
        return !!this.state?.query?.pagination?.[layer.id]?.paginate;
      },

      /**
       * @returns { boolean } whether can show "add to select" action
       */
      canSelect(layer) {
        return (
          !layer.filter.active //@since 4.0.4 In case of filter active, doen't show select action
          && GUI.getService('queryresults').getActionLayerById({ layer, id: 'selection' })
          && (!this.canPaginate(layer) || (layer.selection.active && layer.filter.active))
        );
      },

      /**
       * @param { Object } layer
       * 
       * @return { boolean } whether layer need to be show on query result list
       * 
       * @since 3.9.1
       */
      showLayer(layer) {
        return (
          layer.show &&                    // check if is set show
          (
            layer?.features?.length > 0 // whether has at least one feature
            || layer.rawdata            // whether has rawdata
            || layer?.infoformats?.length > 0 // whether has info formats (eg. external wms layer)
          )
        )
      },

      /**
       * @param { string }              id //layer id
       * @param { 'feature' | 'layer' } type
       * @param { 'before' | 'after' }  position
       */
      getLayerCustomComponents(id, type, position) {
        return this.state?.layerscustomcomponents?.[id]?.[type]?.[position] || [];
      },

      getLayerField({ layer, feature, fieldName }) {
        return {
          ...layer.attributes.find(a => fieldName === a.name), // layer field
          label: null,                                         // hide label in query result (dom table value content)
          value: Array.isArray(feature.attributes[fieldName]) ? feature.attributes[fieldName].join(',') : feature.attributes[fieldName],
        };
      },

      getQueryFields(layer, feature) {
        const fields = [];
        for (const field of layer.formStructure.fields) {
          const _field = {
            ...field,
            query: true,
            //@since 4.1.0 support array value https://github.com/g3w-suite/g3w-client-plugin-editing/issues/186
            value: feature.attributes[field.name] ?? feature.attributes[field.name.replace(/ /g,"_")],
          };
          _field.input = { type: `${this.getFieldType(_field)}` };
          fields.push(_field);
        }
        return fields;
      },

      getColSpan(layer) {
        return this.attributesSubset(layer).length + (!this.hasLayerOneFeature(layer)*1);
      },

      addLayerFeaturesToResults(layer) {
        GUI.addLayerFeaturesToResultsAction(layer);
      },

      printAtlas(layer) {
        GUI.printAtlas(layer);
      },

      showDownloadModal(layer) {
        downloadFeatures({
          layer,
          features:          layer.features,
          down_with_polygon: 'polygon' === this.state.query.type && `${ this.state.query.fid }`,
          filter: this.state.query?.pagination?.getData?.params?.[layer.id] && {
            ...('search' === this.state.query.type 
              ? { field: this.state.query?.pagination?.getData?.params?.[layer.id]?.filter } 
              : this.state.query?.pagination?.getData?.params?.[layer.id]?.download 
            ),
          },
        });
      },

      hasLayerOneFeature(layer) {
        return 1 === layer.features.length;
      },

      /**
       * @param layer
       *
       * @since 3.9.0
       */
      saveFilter(layer) {
        getCatalogLayerById(layer.id).saveFilter();
      },

      async toggleFilter(layer) {
        await getCatalogLayerById(layer.id).toggleToken();
      },

      hasFormStructure(layer) {
        return !!layer.formStructure;
      },

      async toggleSelection(layer) {
        await GUI.toggleSelection(layer);
      },

      attributesSubset(layer) {
        let attributes;
        
        // extract attributes from first tab of form structure layers
        if (this.hasFormStructure(layer)) {
          const attrs = new Set();
          const traverse = item => {
            if (item.nodes) {
              item.nodes.forEach(n => traverse(n));
            } else {
              let field = layer.formStructure.fields.find(f => item.field_name === f.name);
              if (field) {
                if ('ows'=== this.state.type) {
                  // clone it to avoid replacing original
                  field = { ...field };
                  field.name = field.name.replace(/ /g, '_');
                }
                attrs.add(field);
              }
            }
          };
          (layer.formStructure.structure || []).forEach(struct => traverse(struct));
          attributes = Array.from(attrs);
        } else {
          attributes = layer.attributes;
        }
        const _attributes = attributes.filter(a => a.show && HEADERTYPESFIELD.includes(a.type));
        // TODO: find a clever way to handle geocoding results..
        const end = Math.min(/*'__g3w_marker' === layer.id ? 0 :*/ layer.max_preview_fields, attributes.length);
        return _attributes.slice(0, end);
      },

      getLayerFormStructure(layer) {
        return layer.formStructure.structure.map(n => Vue.observable(structuredClone(n))); // clone deep + set reactive with Vue.observable
      },

      getLayerFeatureBox(layer, feature, relation_index) {
        const boxid = GUI.getBoxId(layer, feature, relation_index);
        if (undefined === this.state.layersFeaturesBoxes[boxid] ) {
          this.state.layersFeaturesBoxes[boxid] = Vue.observable({ collapsed: true });
          this.state.layersFeaturesBoxes[boxid].collapsed = layer.features.length > 1;
        }
        return this.state.layersFeaturesBoxes[boxid];
      },

      // to CHECK NOT GOOD
      collapsedFeatureBox(layer, feature, relation_index) {
        return this.state.layersFeaturesBoxes[GUI.getBoxId(layer, feature, relation_index)]?.collapsed ?? true;
      },

      showFeatureInfo(layer, boxid) {
        GUI.emit('show-query-feature-info', {
          layer,
          tabs: this.hasFormStructure(layer),
          show: !((this.state.layersFeaturesBoxes[boxid] ?? { collapsed: true }).collapsed),
        });
      },

      /**
       * Show only features that have show true and in case of active filter, only selected
       * 
       * @since 3.11.8
       */
      showFeature(layer, feature) {
        return GUI.showFeature(layer, feature);
      },

      async toggleFeatureBox(layer, feature, relation_index) {
        const boxid = GUI.getBoxId(layer, feature, relation_index);
        this.state.layersFeaturesBoxes[boxid].collapsed = !this.state.layersFeaturesBoxes[boxid].collapsed;
        await this.$nextTick();
        this.showFeatureInfo(layer, boxid);
      },

      toggleFeatureBoxAndZoom(layer, feature, relation_index) {
        if (!this.hasLayerOneFeature(layer)) {
          this.toggleFeatureBox(layer, feature, relation_index);
        }
      },

      async trigger(action, layer, feature, index) {
        //In case of action is disbled do nothing
        if (this.state.download || !!(action.state || {}).disabled) {
          return;
        }
        
        if (action.opened && 'none' === document.getElementById(`${layer.id}_${index}`)?.style?.display) {
          this.toggleFeatureBox(layer, feature);
          await this.$nextTick();
        }
        if ('highlightgeometry' === action.id) {
          GUI.highlight(layer, feature, index);
        }
        if ('clearHighlightGeometry' === action.id) {
          GUI.highlight(false);
        }
        const _action = layer && GUI.getActionLayerById({ layer, id: action.id });
        if (_action?.cbk) {
          await _action.cbk(layer, feature, _action, index, $(`#${layer.id}_${index} > td`));
        }
      },

      openLink(link_url) {
        window.open(link_url, '_blank');
      },

      /**
       * @since 3.9.0
       */
       isJSON(field) {
        return !this.isVue(field) && this.isSimple(field) && 'Object' === toRawType(field.value);
      },

      /**
       * @param layer
       * 
       * @returns { boolean } whether can open attribute table for layer
       * 
       * @since 4.1.1
       */
      canOpenAttibuteTable(layer) {
        return !layer.external && !getCatalogLayerById(layer.id)?.state?.not_show_attributes_table;
      },

      /**
       * @since 3.10.0
       */
      openAttributeTable(layer) {
        getCatalogLayerById(layer.id).openAttributeTable({ perc: 100 });
      },

      /**
       * Highlight all features of layer
       *
       * @param layer
       * @param opts
       *
       * @since 4.1.0
       */
      highlightLayer(layer, opts = {}) {
        if (layer.hasgeometry) {
          const features = (layer.features || []).filter(f => GUI.showFeature(layer, f));
          const async    = document.querySelector('#g3w-view-content')?.classList?.contains?.('full-size');
          GUI.once('asyncFnc.todo', () => {
            let type, geometry;
            const coordinates = features
              .map(f => f.getGeometry ? f.getGeometry() : f.geometry)
              .map(geom => {
                type = type ? type : (geom instanceof ol.geom.Geometry) ? geom.getType() : geom.type;
                return geom?.getCoordinates?.() ?? geom.coordinates;
              });
            // whether features have geometry
            if (coordinates.length > 0) {
              try {
                geometry = new ol.geom[type.includes('Multi') ? type : `Multi${type}`](type.includes('Multi') ? coordinates.flat(): coordinates);
              } catch(e) {
                console.warn(e);
              }
            }
            GUI.highlight(geometry, opts);
          });
          if (!async) {
            GUI.emit('asyncFnc.todo');
          }
        }
      },

      /**
       * @since 3.11.0
       */
      collapseSidebar(e) {
        const box       = e.target.closest(".box");
        const collapsed = box.classList.contains('collapsed-box');
        box.classList.toggle('collapsed-box');
        box.querySelector(".btn-collapser").classList.toggle('fa-caret-right', !collapsed);
        box.querySelector(".btn-collapser").classList.add('fa-caret-down', collapsed);
      },

      /**
       * @param { number } id    layer id
       * @param { number } page  page number
       * @param { number } size  features per page
       */
      async changePage(id, page, size) {
        const { query, queried_layers } = this.state;
        const index                     = queried_layers.findIndex(l => id === l.id);
        queried_layers[index].loading   = true;
        GUI.disableContent(true);

        try {
          // set current features count shown by selection 
          if (undefined !== size) {
            query.pagination[id].current_sizes = size;
          }

          const page_size = query.pagination[id].current_sizes;

          // remove "autofilter" parameter (on first request)
          if (query.autofilter && query.pagination[id].paginate) {
            query.autofilter = false;
            Object.keys(query.pagination.getData.params).forEach(id => delete query.pagination.getData.params[id].autofilter);
          }

          // set page size
          if (page_size) {
            query.pagination.getData.params[id].page_size = page_size;
          }

          // get config from getData object
          const layer           = query.pagination[id].layer;

          // whehter layer has filter
          const has_filtertoken = !!layer.getToken();

          if ('search' === query.type) {
            query.pagination.getData.params[id].field = this.state.query?.pagination?.getData?.params?.[id]?.filter;
          }
          const data = await layer[query.pagination.getData.method]({ ...query.pagination.getData.params[id], page });
          
          // set response data
          GUI.setQueryResponse(
            { ...data, query },
            { add: false, update: true }
          );

          Object.assign(query.pagination[id], {
            paginate: data.count > (data.data || [])[0].features.length, // paginate in base of change amount of features request changing select value on query result
            pages:    Math.ceil(data.count / page_size),                 // new number of pages
            current:  page,                                              // current page
          });

          // set filter pagination in case of all features are get from pagination
          queried_layers[index].filter.pagination  = queried_layers[index].filter.active && query.pagination[id].paginate;

          const page_size_change                   = layer.state.selection.active || has_filtertoken ;

          // get selection action
          const action = this.state.layersactions[layer.getId()].find(({ id }) => 'selection' === id);

          queried_layers[index].features.forEach((f, i) => {
            if (page_size_change && !f.selected && f.geometry && layer.isGeoLayer()) {
              GUI.toggleSelection(queried_layers[index], f, 'paginate');
            }
            f.selected              = page_size_change;
            action.state.toggled[i] = page_size_change;
          });

          layer.state.filter.active    = page_size_change;
          layer.state.selection.active = page_size_change;

          // zoom to features when layer has geometry
          if (queried_layers[index].hasgeometry) {
            this.highlightLayer(queried_layers[index], { zoom: false });
          }
        } catch(e) {
          console.warn(e);
        }

        GUI.disableContent(false);
        queried_layers[index].loading = false;
      },

      /**
       * @since 4.1.0 
       */
      async changeInfoFormat(layer, contenttype) {
        layer.loading     = true;
        try {
          const catalog_layer = getCatalogLayerById(layer.id);

          if (!this.proxied_layers.includes(catalog_layer)) {
            this.proxied_layers.push(catalog_layer);
          }
          
          const response      = await catalog_layer.fetchProxyData('wms', { changes: {
            headers: { 'Content-Type': contenttype },
            params:  { INFO_FORMAT:    contenttype }
          }});

          layer.infoformat = contenttype;

          catalog_layer.setInfoFormat(layer.infoformat);

          const [data] = Layer._parse(contenttype, { layers: [catalog_layer], response });
          // parse as raw data
          if (!data.features) {
            layer.features.splice(0);
            await this.$nextTick();
            layer.rawdata     = data.rawdata;
            layer.hasgeometry = false;
          }

          // parse data
          if (data.features) {
            layer.rawdata = null;
            data.features.forEach(f => {
              const feature = {
                id:         f instanceof ol.Feature ? f.getId()         : f.id,
                attributes: f instanceof ol.Feature ? f.getProperties() : f.properties,
                geometry:   f instanceof ol.Feature ? f.getGeometry()   : f.geometry,
                show:       true,
              };
              // raw data (html) → set attributes to visualize it on result
              if (0 === layer.attributes.length) {
                layer.hasgeometry = !!feature.geometry;
                GUI.setActionsForLayers([layer]);
                getAlphanumericProps(feature.attributes).forEach(name => layer.attributes.push({ name, label: name, show: true, type: 'varchar' }));
              }
              layer.features.push(feature);
            });
          }
        } catch(e) {
          console.warn(e);
        }
        layer.loading = false;
      },

      /**
       * @returns a cached, per-feature action list.
       * 
       * @since 4.2.0
       */
      getFeatureActions({ actions = [], layer, feature, index } = {}) {
        const key = `${layer.id}__${feature?.id ?? index}`;

        // store it into cache (per layer/feature, to avoid render loops)
        if (!this.layer_feature_actions[key]) {
          this.$set(this.layer_feature_actions, key, actions);
          (async () => {
            for (const action of actions) {
              let show = true;
              // evaluate action visibility (for this feature)
              if ('function' === typeof action.condition) {
                try {
                  show = await action.condition({ layer, feature });
                } catch(e) {
                  console.warn(e);
                  show = false;
                }
              }
              // keep visibility consistent with action state
              show = show && (undefined === (action.state || {}).show ? true : action.state.show);
              // init only visible actions
              if (show && action.init) {
                action.init({ layer, feature, index, action });
              }
              // register cleanup (only for active actions)
              if (show && 'function' === typeof action.clear) {
                this.clear_actions.push(() => action.clear({ action, layer, feature }));
              }
              // remove hidden actions (from cache)
              if (!show) {
                this.layer_feature_actions[key] = this.layer_feature_actions[key].filter(a => a !== action);
              }
            }
          })();
        }

        // return cached action
        return this.layer_feature_actions[key];
      },
    },

    watch: {

      async 'state.queried_layers'(queried_layers = []) {

        //reset feature actions cache to avoid render loops
        this.layer_feature_actions = {};

        queried_layers.forEach(layer => {
          if (layer.attributes.length <= layer.max_preview_fields && !layer.hasImageField) {
            layer.expandable = false;
          }
          layer.features.forEach(feature => {
            this.getLayerFeatureBox(layer, feature);
            if (feature.attributes.relations) {
              feature.attributes.relations
                .forEach(relation => {
                  relation.elements
                    .forEach((_, index) => this.state.layersFeaturesBoxes[`${layer.id}_${feature.id}_${relation.name}${index}`] = { collapsed: true });
                })
            }
          })
        });

        // check if is a single result layer and if it has one feature
        if (this.onelayerresult && this.hasLayerOneFeature(queried_layers[0])) {
          const layer   = queried_layers[0];
          const boxid   = GUI.getBoxId(layer, layer.features[0]);
          GUI.onceafter('postRender', () => this.showFeatureInfo(layer, boxid));
        }
        requestAnimationFrame(() => GUI.postRender(this.$el));
        await this.$nextTick();
      },

      onelayerresult(bool) {
        if (bool && !this.state.query?.pagination?.[this.state.queried_layers[0].id]?.paginate && !this.state.queried_layers[0].filter.active) {
          let type, geometry;
          const coordinates = this.state.queried_layers[0].features
            .map(f => f.getGeometry ? f.getGeometry() : f.geometry)
            .map(geom => {
              type = type ? type : (geom instanceof ol.geom.Geometry) ? geom.getType() : geom?.type;
              return geom?.getCoordinates?.() ?? geom?.coordinates;
            })
            .filter(c => c); //filter geometry valid

          //check if features have geometry
          if (coordinates.length > 0) {
            try {
              geometry = new ol.geom[type.includes('Multi') ? type : `Multi${type}`](type.includes('Multi') ? coordinates.flat(): coordinates);
            } catch(e) {
              console.warn(e);
            }
          }
          GUI.highlightGeometry(geometry, { duration: Infinity, zoom: false });
        }
      }

    },

    created() {
      this.zoomToLayer   = throttle(l => GUI.zoomToLayer(l));
      this.clear_actions = [];
    },
    
    beforeDestroy() {
      this.proxied_layers.forEach(l => l?.clearProxyData?.('wms'));
      this.clear_actions.forEach(clear => clear());
      this.proxied_layers = [];
      this.clear_actions  = [];
    },

    destroyed() {
      GUI.clear();
    },

  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"queryresults-wrapper",attrs:{"id":"search-results"}},[(_vm.info.message)?_c('p',{staticStyle:{"font-size":"1.1em"}},[(_vm.info.icon)?_c('i',{class:_vm.$fa(_vm.info.icon),attrs:{"aria-hidden":"true"}}):_vm._e(),_vm._v(" "),_c('b',[_vm._v(" "+_vm._s(_vm.info.message)+" ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"queryresults-container"},[(_vm.state.queried_layers.length && _vm.hasLayers)?_c('ul',{staticClass:"queryresults",staticStyle:{"position":"relative"},attrs:{"id":"queryresults"}},[_vm._l((_vm.state.queried_layers.filter(function (l) { return _vm.showLayer(l); })),function(layer){return _c('li',[_c('bar-loader',{attrs:{"loading":layer.loading}}),_vm._v(" "),_c('div',{staticClass:"box box-primary"},[_c('div',{staticClass:"box-header with-border",on:{"mouseover":function($event){$event.stopPropagation();!_vm.isMobile() && _vm.highlightLayer(layer, { zoom: false, highlight: true, duration: Infinity })},"mouseout":function($event){$event.stopPropagation();!_vm.isMobile() && _vm.highlightLayer(layer, { zoom: false, highlight: false })},"click":function($event){$event.stopPropagation();return _vm.collapseSidebar.apply(null, arguments)}}},[_c('button',{staticClass:"btn-box-tool btn-collapser skin-color-dark fas fa-caret-down",staticStyle:{"font-weight":"900","font-size":"1.75rem","border":"none","margin-left":"5px"},attrs:{"type":"button","title":"Enlarge / Reduce"}}),_vm._v(" "),_c('div',{staticClass:"box-title query-layer-title",style:({ fontSize: _vm.isMobile() && '1em !important' })},[(_vm.canOpenAttibuteTable(layer))?_c('button',{staticClass:"action-button",attrs:{"type":"button","title":"Open Attribute Table","data-placement":"left"},on:{"click":function($event){$event.stopPropagation();return _vm.openAttributeTable(layer)}}},[_c('i',{staticClass:"fas fa-list-alt",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v("\n              "+_vm._s(layer.title)+"\n              "),(!layer.rawdata)?_c('span',[_vm._v("\n                ("+_vm._s(_vm.canPaginate(layer)
                    ? (layer.features.length + ((_vm.state.query.pagination[layer.id].current - 1) * _vm.state.query.pagination.getData.params[layer.id].page_size)) + ' - ' + _vm.state.query.pagination[layer.id].count
                    : layer.features.length)+")\n              ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"query-layer-actions",staticStyle:{"display":"flex","gap":"2.5px","padding-right":"10px"}},[((layer.infoformats || []).length)?_c('select',{staticClass:"form-control",attrs:{"disabled":layer.loading},on:{"change":function($event){return _vm.changeInfoFormat(layer, $event.target.value)},"click":function($event){$event.stopPropagation();}}},_vm._l((layer.infoformats),function(format){return _c('option',{key:format,domProps:{"value":format,"selected":format === layer.infoformat}},[_vm._v("\n                  "+_vm._s(format)+"\n                ")])}),0):_vm._e(),_vm._v(" "),(layer.hasgeometry)?_c('button',{staticClass:"action-button",attrs:{"type":"button","title":"Zoom to features extent","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.zoomToLayer(layer)}}},[_c('i',{staticClass:"fas fa-map-marker-alt",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(layer.atlas.length)?_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.download),expression:"state.download"}],staticClass:"action-button",attrs:{"type":"button","title":"Print Atlas","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.printAtlas(layer)}}},[_c('i',{staticClass:"fas fa-print",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),((layer.downloads || []).filter(function (d) { return 'pdf' !== d; }).length > 0)?_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.download),expression:"state.download"}],staticClass:"action-button",class:{ 'toggled': layer.downloadformats.active },attrs:{"type":"button","title":"Downloads","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.showDownloadModal(layer)}}},[_c('i',{staticClass:"fas fa-download",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(layer.external || (!layer.filter.active && layer.source && !['wms', 'arcgismapserver'].includes(layer.source.type) && !(_vm.state.query && _vm.state.query.pagination)))?_c('button',{staticClass:"action-button",class:{ 'toggled': layer.addfeaturesresults.active },attrs:{"type":"button","title":"Add/Remove features to results","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.addLayerFeaturesToResults(layer)}}},[_c('i',{staticClass:"fas fa-plus-square",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(_vm.canSelect(layer))?_c('button',{staticClass:"action-button",class:{ 'toggled': layer.selection.active && layer.features.every(function (f) { return f.selected; }) },attrs:{"type":"button","title":"Add/Remove Selection","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleSelection(layer)}}},[_c('i',{staticClass:"fas fa-check-circle",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(
                  !layer.external
                  && layer.selection.active
                  && !layer.filter.pagination
                  && layer.features.some(function (f) { return f.selected; })
                )?_c('button',{staticClass:"action-button",class:{'toggled': layer.filter.active },attrs:{"type":"button","title":"Enable/Disable filter","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFilter(layer)}}},[_c('i',{staticClass:"fas fa-filter",attrs:{"aria-hidden":"true"}})]):_vm._e(),_vm._v(" "),(
                  !layer.external
                  && layer.selection.active
                  && _vm.state.logged
                  && layer.filter.active
                  && (null === layer.filter.current || layer.selection.active)
                )?_c('button',{staticClass:"action-button",attrs:{"type":"button","title":"Save Filter","data-placement":"top"},on:{"click":function($event){$event.stopPropagation();return _vm.saveFilter(layer)}}},[_c('i',{staticClass:"fas fa-save",attrs:{"aria-hidden":"true"}})]):_vm._e()])]),_vm._v(" "),(_vm.state.layeractiontool[layer.id].component)?_c('div',{staticClass:"g3w-layer-action-tools with-border",staticStyle:{"padding":"5px"}},[_c(_vm.state.layeractiontool[layer.id].component,{tag:"component",attrs:{"layer":layer,"config":_vm.state.layeractiontool[layer.id].config}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'layer', 'before')),function(ref){
                var component = ref.component;
return _c(component,{tag:"component",attrs:{"layer":layer}})}),_vm._v(" "),(_vm.state.query.pagination && _vm.state.query.pagination[layer.id] && _vm.state.query.pagination[layer.id].page_sizes.length > 1)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(layer.loading),expression:"layer.loading"}],attrs:{"id":"g3w-queryresults-pagination"}},[_c('select',{staticClass:"form-control",staticStyle:{"width":"auto"},on:{"change":function($event){_vm.changePage(layer.id, 1, Number($event.target.value))}}},_vm._l((_vm.state.query.pagination[layer.id].page_sizes),function(page){return _c('option',{key:page,domProps:{"value":page}},[_vm._v(_vm._s(page))])}),0),_vm._v(" "),_c('ul',{staticStyle:{"display":"flex","align-items":"center"},attrs:{"disabled":!layer.loading}},[_c('li',[(_vm.state.query.pagination[layer.id].count > layer.features.length)?_c('button',{staticClass:"btn fas fa-angle-left",attrs:{"disabled":1 === _vm.state.query.pagination[layer.id].current},on:{"click":function($event){$event.stopPropagation();return _vm.changePage(layer.id, _vm.state.query.pagination[layer.id].current - 1)}}}):_vm._e()]),_vm._v(" "),_c('li',[_c('button',{directives:[{name:"disabled",rawName:"v-disabled",value:(layer.features.length === _vm.state.query.pagination[layer.id].count),expression:"layer.features.length === state.query.pagination[layer.id].count"}],staticClass:"btn",class:{ 'skin-background-color': 1 === _vm.state.query.pagination[layer.id].current },on:{"click":function($event){$event.stopPropagation();return _vm.changePage(layer.id, 1)}}},[_vm._v("1")])]),_vm._v(" "),(_vm.state.query.pagination[layer.id].count > layer.features.length && _vm.state.query.pagination[layer.id].pages > 4 && _vm.state.query.pagination[layer.id].current > 2)?_c('li',[_vm._v("…")]):_vm._e(),_vm._v(" "),_c('li',[(_vm.state.query.pagination[layer.id].pages > 1 && _vm.state.query.pagination[layer.id].count > layer.features.length)?_vm._l(((
                    (_vm.state.query.pagination[layer.id].pages < 4 || _vm.state.query.pagination[layer.id].current < 3)
                      ? Array.from(Array(_vm.state.query.pagination[layer.id].pages - 2).keys()).slice(0, 2).map(function (i) { return i + 2; })
                      : (_vm.state.query.pagination[layer.id].pages - _vm.state.query.pagination[layer.id].current) > 2
                      ? [_vm.state.query.pagination[layer.id].current, _vm.state.query.pagination[layer.id].current + 1 ]
                      : [_vm.state.query.pagination[layer.id].pages - 2, _vm.state.query.pagination[layer.id].pages - 1 ]
                    )),function(page){return _c('button',{staticClass:"btn",class:{ 'skin-background-color': page === _vm.state.query.pagination[layer.id].current },on:{"click":function($event){$event.stopPropagation();return _vm.changePage(layer.id, page)}}},[_vm._v(_vm._s(page)+"\n                  ")])}):_vm._e()],2),_vm._v(" "),(_vm.state.query.pagination[layer.id].count > layer.features.length && _vm.state.query.pagination[layer.id].pages > 4 && (_vm.state.query.pagination[layer.id].current < _vm.state.query.pagination[layer.id].pages - 2))?_c('li',[_vm._v("…")]):_vm._e(),_vm._v(" "),_c('li',[(_vm.state.query.pagination[layer.id].count > layer.features.length && _vm.state.query.pagination[layer.id].pages > 1)?_c('button',{staticClass:"btn",class:{ 'skin-background-color': _vm.state.query.pagination[layer.id].pages === _vm.state.query.pagination[layer.id].current },on:{"click":function($event){$event.stopPropagation();return _vm.changePage(layer.id, _vm.state.query.pagination[layer.id].pages)}}},[_vm._v("\n                  "+_vm._s(_vm.state.query.pagination[layer.id].pages)+"\n                ")]):_vm._e()]),_vm._v(" "),_c('li',[(_vm.state.query.pagination[layer.id].count > layer.features.length)?_c('button',{staticClass:"btn fas fa-angle-right",attrs:{"disabled":_vm.state.query.pagination[layer.id].pages === _vm.state.query.pagination[layer.id].current},on:{"click":function($event){$event.stopPropagation();return _vm.changePage(layer.id, _vm.state.query.pagination[layer.id].current + 1)}}}):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"box-body"},[(layer.rawdata)?_c('iframe',{key:((layer.id) + "_" + (layer.infoformat) + "_" + ((layer.rawdata || '').length) + "_" + ((layer.rawdata || '').charCodeAt(0) || 0)),staticStyle:{"width":"100%","border":"none"},attrs:{"sandbox":"allow-same-origin","scrolling":"no"},on:{"load":function($event){return _vm.setRawdataIframeContent($event, layer)}}}):_c('table',{staticClass:"table"},_vm._l((layer.features.filter(function (f) { return _vm.showFeature(layer, f); })),function(feature,index){return _c('tbody',{key:feature.id},[_c('tr',{staticClass:"featurebox-header",on:{"mouseover":function($event){$event.stopPropagation();feature.geometry && _vm.trigger({ id: 'highlightgeometry'}, layer, feature, index)},"mouseout":function($event){$event.stopPropagation();feature.geometry && _vm.trigger({ id: 'clearHighlightGeometry'}, layer, feature, index)}}},[(_vm.state.layersactions[layer.id].length > 0)?_c('td',{staticClass:"g3w-feature-actions",staticStyle:{"padding":"3px"},attrs:{"colspan":_vm.getColSpan(layer)}},_vm._l((_vm.getFeatureActions({ actions: _vm.state.layersactions[layer.id], layer: layer, feature: feature, index: index })),function(action){return ((action.state && action.state.show) || true)?_c('button',{key:action.id,staticClass:"action-button",class:{'toggled': (action.state || {}).toggled && action.state.toggled[index], 'disabled' :_vm.state.download || !!(action.state || {}).disabled },attrs:{"type":"button","title":action.hint,"data-placement":"top"},on:{"contextmenu":function($event){$event.preventDefault();$event.stopPropagation();},"click":function($event){$event.stopPropagation();return _vm.trigger(action, layer, feature, index)}}},[_c('i',{class:(action.class || ''),staticStyle:{"padding":"2px"},style:(action.style),attrs:{"aria-hidden":"true"}})]):_vm._e()}),0):_vm._e()]),_vm._v(" "),_c('tr',{staticClass:"g3w-feature-result-action-tools"},[(_vm.state.currentactiontools[layer.id][index])?_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(_vm.state.currentactiontools[layer.id][index],{tag:"component",attrs:{"colspan":_vm.getColSpan(layer),"layer":layer,"feature":feature,"featureIndex":index,"config":_vm.state.actiontools[_vm.state.currentactiontools[layer.id][index].name][layer.id]}})],1):_vm._e()]),_vm._v(" "),(!_vm.hasLayerOneFeature(layer))?_c('tr',{staticStyle:{"font-weight":"bold","text-align":"center"}},[_vm._l((_vm.attributesSubset(layer)),function(attribute,index){return _c('td',{staticClass:"centered"},[_vm._v("\n                    "+_vm._s(_vm.getLayerFeatureBox(layer, feature).collapsed ? attribute.label : '')+"\n                  ")])}),_vm._v(" "),_c('td',{staticClass:"collapsed",class:{noAttributes: _vm.attributesSubset(layer).length === 0},staticStyle:{"text-align":"end"},on:{"click":function($event){$event.stopPropagation();return _vm.toggleFeatureBoxAndZoom(layer,feature)}}},[_c('span',{staticClass:"fa link morelink skin-color",class:_vm.getLayerFeatureBox(layer, feature).collapsed  ? 'fas fa-plus': 'fas fa-minus',attrs:{"title":"Enlarge / Reduce"}})])],2):_vm._e(),_vm._v(" "),(!_vm.hasLayerOneFeature(layer) && _vm.getLayerFeatureBox(layer, feature).collapsed)?_c('tr',[_vm._l((_vm.attributesSubset(layer)),function(attribute){return _c('td',{staticClass:"attribute"},[(_vm.isLink(_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name})))?_c('i',{staticClass:"skin-color fas fa-link",attrs:{"aria-hidden":"true"}}):(_vm.isPhoto(_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name})) || _vm.isImage(_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name})))?_c('g3w-image',{attrs:{"state":_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name})}}):_c('span',{domProps:{"innerHTML":_vm._s(feature.attributes[attribute.name])}})],1)}),_vm._v(" "),(!_vm.hasLayerOneFeature(layer))?_c('td'):_vm._e()],2):_vm._e(),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'before')),function(ref){
                    var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":_vm.getColSpan(layer)}},[_c(component,{tag:"component",class:_vm.hasFormStructure(layer) ? '': 'box-body',attrs:{"layer":layer,"feature":feature}})],1)])}),_vm._v(" "),_c('tr',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsedFeatureBox(layer,feature) || _vm.hasLayerOneFeature(layer)),expression:"!collapsedFeatureBox(layer,feature) || hasLayerOneFeature(layer)"}],staticClass:"featurebox-body",attrs:{"id":((layer.id) + "_" + index)}},[_c('td',{attrs:{"colspan":_vm.getColSpan(layer),"feature-html-content":((layer.id) + "_" + index)}},[(_vm.hasFormStructure(layer))?_c('tabs',{attrs:{"fields":_vm.getQueryFields(layer, feature),"layerid":layer.id,"feature":feature,"tabs":_vm.getLayerFormStructure(layer)}}):_c('table',{staticClass:"feature_attributes"},[_vm._l((layer.attributes.filter(function (attribute) { return attribute.show; })),function(attribute){return [(_vm.isJSON(_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name})))?[_vm._l((_vm.getLayerField({layer: layer, feature: feature, fieldName: attribute.name}).value),function(v,k){
                    var _obj;
return _vm._l((('object' === typeof v ? v : ( _obj = {}, _obj[k] = v, _obj ))),function(v2,k2){return _c('tr',{staticStyle:{"padding-top":"10px","padding-bottom":"10px"}},[_c('td',{staticClass:"attr-label"},[_vm._v(_vm._s(attribute.label)+"."),(('object' === typeof v))?[_vm._v(_vm._s(k)+".")]:_vm._e(),_vm._v(_vm._s(k2))],2),_vm._v(" "),_c('td',{staticClass:"attr-value"},[_vm._v(_vm._s(v2))])])})})]:_c('tr',[_c('td',{staticClass:"attr-label"},[_vm._v(_vm._s(attribute.label))]),_vm._v(" "),_c('td',{staticClass:"attr-value",attrs:{"attribute":attribute.name}},[(_vm.isVue(_vm.getLayerField({    layer: layer, feature: feature, fieldName: attribute.name})))?_c('g3w-vue',{attrs:{"feature":feature,"state":_vm.getLayerField({ layer: layer, feature: feature, fieldName: attribute.name })}}):(_vm.isSimple(_vm.getLayerField({ layer: layer, feature: feature, fieldName: attribute.name})))?_c('span',{domProps:{"innerHTML":_vm._s(_vm.getLayerField({ layer: layer, feature: feature, fieldName: attribute.name }).value)}}):(_vm.isPhoto(_vm.getLayerField({  layer: layer, feature: feature, fieldName: attribute.name})))?_c('g3w-image',{attrs:{"state":_vm.getLayerField({ layer: layer, feature: feature, fieldName: attribute.name })}}):(_vm.isImage(_vm.getLayerField({  layer: layer, feature: feature, fieldName: attribute.name})))?_c('g3w-image',{attrs:{"state":_vm.getLayerField({ layer: layer, feature: feature, fieldName: attribute.name })}}):(_vm.isLink(_vm.getLayerField({   layer: layer, feature: feature, fieldName: attribute.name})))?_c('g3w-link',{attrs:{"state":{ value: _vm.getLayerField({ layer: layer, feature: feature, fieldName: attribute.name }).value }}}):_vm._e()],1)])]})],2)],1)]),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'feature', 'after')),function(ref){
                    var component = ref.component;
return _c('tr',[_c('td',{attrs:{"colspan":"getColSpan(layer)"}},[_c(component,{tag:"component",class:_vm.hasFormStructure(layer) ? '': 'box-body',attrs:{"layer":layer,"feature":feature}})],1)])})],2)}),0)]),_vm._v(" "),_vm._l((_vm.getLayerCustomComponents(layer.id, 'layer', 'after')),function(ref){
                    var component = ref.component;
return _c('div',{staticClass:"box-body",class:{'mobile': _vm.isMobile()}},[_c(component,{tag:"component",attrs:{"layer":layer}})],1)})],2)],1)}),_vm._v(" "),_vm._l((_vm.state.components),function(component){return _c('li',[_c(component,{tag:"component",on:{"showresults":function($event){return _vm.showResults()}}})],1)})],2):(!_vm.state.queried_layers.length && _vm.state.changed)?_c('div',{staticClass:"query-results-not-found"},[_c('h4',{directives:[{name:"t",rawName:"v-t",value:('info.no_results'),expression:"'info.no_results'"}],staticClass:"skin-color",staticStyle:{"font-weight":"bold","text-align":"center"}})]):_vm._e()]),_vm._v(" "),(_vm.state.query)?_c('div',{staticStyle:{"visibility":"hidden","position":"sticky","bottom":"-8px","background":"#eee","padding":"8px 0","display":"flex","gap":"1em"}},[_c('label',{staticStyle:{"margin-top":"5px"}},[_vm._v(_vm._s(_vm.$t('Filter by:')))]),_vm._v(" "),_c('select',{staticStyle:{"flex":"1"}},[_vm._l((_vm.queryableLayers),function(layer){return _c('option',{domProps:{"selected":layer === _vm.selectedLayer}},[_vm._v(_vm._s(layer.getName()))])}),_vm._v(" "),_c('option',{domProps:{"selected":!_vm.selectedLayer}},[_vm._v(_vm._s(_vm.$t('__ALL__')))])],2)]):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-e561a5ec_0", { source: ".noAttributes[data-v-e561a5ec]{display:flex;justify-content:flex-end}.g3w-feature-actions[data-v-e561a5ec]{padding:3px;background-color:rgba(34,45,50,.1)!important}.feature_attributes tr[data-v-e561a5ec]{line-height:1.8em}.featurebox-body+tr[data-v-e561a5ec]{border-top:2px groove #000}#g3w-queryresults-pagination[data-v-e561a5ec]{display:flex;justify-content:space-between;align-items:center;margin-top:15px;flex-wrap:wrap;margin-left:10px}#g3w-queryresults-pagination>ul>li>*[data-v-e561a5ec]{background-color:transparent;margin:2px;font-weight:700;font-size:.8em}.action-button.disabled[data-v-e561a5ec]{cursor:not-allowed;opacity:.5}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-e561a5ec"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "QueryResults.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__